module.exports = __webpack_public_path__ + "img/3_bg.18366b54.png";